export default "__VITE_ASSET__BE6R7hHg__"